"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = exports.hidePreviewAt = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
exports.hidePreviewAt = 900;
const blockClass = (0, nano_theme_1.rule)({
    d: 'flex',
    flw: 'wrap',
    alignItems: 'center',
    fz: '16px',
    us: 'none',
});
const separatorClass = (0, nano_theme_1.rule)({
    d: 'inline-block',
    pad: '0 8px',
    lh: 1,
    op: 0.4,
});
const Breadcrumbs = ({ crumbs, compact, style }) => {
    return (
    // biome-ignore lint/a11y/useAriaPropsSupportedByRole: breadcrumb landmark pattern
    React.createElement("div", { className: blockClass, style: { ...style, fontSize: compact ? '12px' : void 0 }, "aria-label": "breadcrumb" }, crumbs.map((item, index) => {
        const isLast = index === crumbs.length - 1;
        return (React.createElement(React.Fragment, { key: index },
            item,
            !isLast && (React.createElement("span", { className: separatorClass, style: { padding: compact ? '0 2px' : void 0, fontSize: compact ? '11px' : void 0 } }, "/"))));
    })));
};
exports.Breadcrumbs = Breadcrumbs;
